import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import ImageStatic from '../ImageStatic'

import styles from './styles'


const decorators = [
  memoized,
]

function CircularIcon(props) {
  const { icon } = props

  return (
    <div className="container">
      <ImageStatic
        className="icon"
        src={`https:${icon}`}
      />
      <style jsx>{styles}</style>
    </div>
  )
}

CircularIcon.icons = {
  rocket: 'rocket',
  computer: 'computer',
  time: 'time',
}

CircularIcon.propTypes = {
  icon: PropTypes.string.isRequired,
}

CircularIcon = chainDecorators(decorators, CircularIcon)

export default CircularIcon
